<template>
  <div class="substep-setup-call-gap-team">
    <div class="substep-header">
      <h3>Start your Hubstaff setup</h3>
      <p>Rebeca will help you get everything running smoothly in 20 minutes.</p>
    </div>

    <div class="substep-body">
      <div class="setup-call-card">
        <div class="specialist-card">
          <div class="specialist-identity">
            <img
              :src="specialistAvatar"
              alt=""
              class="specialist-avatar"
              width="80"
              height="80"
            />
            <div class="specialist-text">
              <div class="specialist-name">Rebeca Isfer</div>
              <div class="specialist-role">Your setup specialist</div>
            </div>
          </div>
          <AppButton
            type="primary"
            class="schedule-button"
            data-testid="gap-team-schedule-call"
            @click="scheduleCall"
          >
            <i class="hi hi-16 hi-calendar"></i>
            Schedule a call
          </AppButton>
        </div>

        <div class="topics">
          <div class="topics-label">Get 1:1 setup walkthroughs on:</div>
          <div
            v-for="topic in topics"
            :key="topic.key"
            class="topic-tile"
            :data-testid="`topic-${topic.key}`"
          >
            <span class="material-symbols-rounded">{{ topic.icon }}</span>
            <div class="topic-copy">
              <div class="topic-title">{{ topic.title }}</div>
              <p class="topic-description">{{ topic.description }}</p>
              <div
                v-if="topic.key === 'integrations'"
                class="integration-logos"
              >
                <img
                  v-for="logo in integrationLogos"
                  :key="logo.name"
                  :src="logo.src"
                  :alt="logo.name"
                  width="26"
                  height="26"
                />
                <span class="integration-more">+20 others</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '~/components/AppButton.vue';
import {
  AR0231_SPECIALIST_AVATAR,
  AR0231_LOGO_WISE,
  AR0231_LOGO_CLICKUP,
  AR0231_LOGO_SLACK,
  AR0231_LOGO_MONDAY,
  AR0231_LOGO_PAYPAL,
} from '~/rails_assets';

export default {
  name: 'SetupCallGapTeam',
  components: {
    AppButton,
  },
  props: {
    setupCallUrl: {
      type: String,
      required: true,
    },
  },
  emits: ['completeSubstep', 'trackWizardEvent'],
  data: () => ({
    specialistAvatar: AR0231_SPECIALIST_AVATAR,
    integrationLogos: [
      { name: 'Wise', src: AR0231_LOGO_WISE },
      { name: 'Slack', src: AR0231_LOGO_SLACK },
      { name: 'ClickUp', src: AR0231_LOGO_CLICKUP },
      { name: 'Monday', src: AR0231_LOGO_MONDAY },
      { name: 'PayPal', src: AR0231_LOGO_PAYPAL },
    ],
    topics: [
      {
        key: 'monitoring',
        icon: 'insert_chart',
        title: 'Customized monitoring and proof of work',
        description:
          'Configure idle time detection, activity and screenshot settings, and automatic alerting via Smart Notifications.',
      },
      {
        key: 'integrations',
        icon: 'check_circle',
        title: 'Integrations',
        description: 'Connect the tools your team already works in, plus payments.',
      },
      {
        key: 'other-topics',
        icon: 'lightbulb',
        title: 'Other top topics',
        description:
          'Schedules and shifts, Location tracking via Hubstaff’s mobile app, client workflows with Clients and Project Viewers, and more.',
      },
    ],
  }),
  methods: {
    scheduleCall() {
      window.open(this.setupCallUrl, '_blank', 'noopener,noreferrer');
      this.$emit('completeSubstep');
      this.trackScheduled();
    },
    trackScheduled() {
      this.$emit('trackWizardEvent', '0231 Gap Team Setup Call Scheduled', {
        experiment: true,
        source: 'getting started setup call',
        user_role: 'owner',
      });
    },
  },
};
</script>
